// extracted by mini-css-extract-plugin
module.exports = {"totalPrice":"aGi6DI","scentPrice":"_3t32hH","option":"_15SePn","prices":"IuG4CP","shine-lines":"_1q7DGp"};